'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('voting-list', {
      url: '/voting/list',
      template: '<voting-list></voting-list>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/voting/voting-list/voting-list.routes.js